import React from 'react';
import { GapSizeType } from '../../../theme/type/gap-type';
import { cn } from '../../../utils/tailwind';

interface SectionPropsInterface {
    children: React.ReactNode;
    title?: React.ReactNode;
    action?: React.ReactNode;
    footer?: React.ReactNode;
    marginTop?: GapSizeType;
    marginBottom?: GapSizeType;
}

const marginTopClass: Record<GapSizeType, string> = {
    none: 'mt-none',
    xxsmall: 'mt-xxsmall',
    xsmall: 'mt-xsmall',
    vsmall: 'mt-vsmall',
    small: 'mt-small',
    medium: 'mt-medium',
    large: 'mt-large',
    vlarge: 'mt-vlarge',
    xlarge: 'mt-xlarge',
    xxlarge: 'mt-xxlarge',
};

const marginBottomClass: Record<GapSizeType, string> = {
    none: 'mb-none',
    xxsmall: 'mb-xxsmall',
    xsmall: 'mb-xsmall',
    vsmall: 'mb-vsmall',
    small: 'mb-small',
    medium: 'mb-medium',
    large: 'mb-large',
    vlarge: 'mb-vlarge',
    xlarge: 'mb-xlarge',
    xxlarge: 'mb-xxlarge',
};

export const Section: React.FC<SectionPropsInterface> = ({
    title,
    children,
    footer,
    action,
    marginTop,
    marginBottom,
}) => {
    return (
        <div
            className={cn(
                '[&+&]:mt-xlarge',
                marginTop && marginTopClass[marginTop],
                marginBottom && marginBottomClass[marginBottom],
            )}
        >
            <div className="mb-medium flex flex-col xl:flex-row xl:items-center xl:justify-between">
                {title && <div className="text-[1.8rem] font-bold leading-[2.2rem] text-brand-secondary">{title}</div>}
                {action && <div className="mt-medium xl:mt-0">{action}</div>}
            </div>

            <div>{children}</div>

            {footer && <div className="mt-medium flex justify-end">{footer}</div>}
        </div>
    );
};
